export default __webpack_public_path__ + "static/logoife_small_2x-5e998e42d2bf2a5a22b99826e2664c6a.png";